export const urls = {
    Login:'/adminlogin'
}

